import { Moon, Sun } from "lucide-react";
import { useAppTheme } from "@/context/ThemeContext";

export const ThemeToggle = () => {
  const { isDark, toggle } = useAppTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle-button"
      className="relative inline-flex h-9 w-16 items-center rounded-full border bg-muted px-1 transition-colors hover:border-primary/50"
    >
      <span className={`flex h-7 w-7 items-center justify-center rounded-full bg-card shadow-sm transition-transform duration-300 ${isDark ? "translate-x-7" : ""}`}>
        {isDark ? <Moon className="h-4 w-4 text-primary" /> : <Sun className="h-4 w-4 text-accent" />}
      </span>
    </button>
  );
};
